var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeDecor2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 554,
    height: 107,
    viewBox: "0 0 554 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 152.5,
    y1: 56.5,
    x2: 346.5,
    y2: 56.5,
    stroke: "url(#paint0_linear)",
    strokeWidth: 41,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 88.5,
    y1: 12.5,
    x2: 198.5,
    y2: 12.5,
    stroke: "url(#paint1_linear)",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 233.5,
    y1: 12.5,
    x2: 249.5,
    y2: 12.5,
    stroke: "url(#paint2_linear)",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 284.5,
    y1: 12.5,
    x2: 406.5,
    y2: 12.5,
    stroke: "url(#paint3_linear)",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 444.5,
    y1: 12.5,
    x2: 446.5,
    y2: 12.5,
    stroke: "url(#paint4_linear)",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 52.5,
    y1: 12.5,
    x2: 54.5,
    y2: 12.5,
    stroke: "url(#paint5_linear)",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 97,
    x2: 240,
    y2: 97,
    stroke: "url(#paint6_linear)",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 269,
    y1: 97,
    x2: 422,
    y2: 97,
    stroke: "url(#paint7_linear)",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 452,
    y1: 97,
    x2: 464,
    y2: 97,
    stroke: "url(#paint8_linear)",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 492,
    y1: 97,
    x2: 504,
    y2: 97,
    stroke: "url(#paint9_linear)",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 399.5,
    y1: 56.5,
    x2: 438.5,
    y2: 56.5,
    stroke: "url(#paint10_linear)",
    strokeWidth: 41,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 494.5,
    y1: 56.5,
    x2: 533.5,
    y2: 56.5,
    stroke: "url(#paint11_linear)",
    strokeWidth: 41,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 20.5,
    y1: 56.5,
    x2: 98.5,
    y2: 56.5,
    stroke: "url(#paint12_linear)",
    strokeWidth: 41,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -2.5,
    y1: 66.4965,
    x2: 549.497,
    y2: 67.8492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 6.49999,
    y1: 14.4937,
    x2: 553.998,
    y2: 13.4131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -6.99961,
    y1: 14.5193,
    x2: 544.365,
    y2: 5.87147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 0.499983,
    y1: 14.4946,
    x2: 544.499,
    y2: 13.7936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -14.5001,
    y1: 14.4916,
    x2: 552.156,
    y2: 0.540647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 5.00104,
    y1: 14.5376,
    x2: 545.673,
    y2: 1.22631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 8.00001,
    y1: 96.4937,
    x2: 550.999,
    y2: 97.0289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 6.50001,
    y1: 96.5002,
    x2: 554,
    y2: 96.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 6.50021,
    y1: 96.5134,
    x2: 549.271,
    y2: 85.3523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 3.49974,
    y1: 97.9902,
    x2: 550.769,
    y2: 86.7366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: -2.5001,
    y1: 66.4951,
    x2: 556.975,
    y2: 62.7492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 2.00013,
    y1: 68.0178,
    x2: 553.975,
    y2: 64.3221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 0.0000469612,
    y1: 68.5128,
    x2: 550.995,
    y2: 66.8507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CF73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDecor2);
export default __webpack_public_path__ + "static/media/homeDecor2.73cedfd7291a56aad0d708835047e88d.svg";
export { ForwardRef as ReactComponent };